import { render, staticRenderFns } from "./baseForm.vue?vue&type=template&id=efc59cd2&"
import script from "./baseForm.vue?vue&type=script&lang=js&"
export * from "./baseForm.vue?vue&type=script&lang=js&"
import style0 from "./baseForm.vue?vue&type=style&index=0&id=efc59cd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports